<template>
	<div class="row">
		<div class="col-md-8">
			<card
				class="no-border-card"
				header-classes="bg-dark d-flex justify-content-between align-items-center"
				body-classes="p-0 pb-1"
				footer-classes="pb-2 border-0"
			>
				<template slot="header">
					<h3 class="mb-0 text-white">รายการผู้ใช้งานทั้งหมด</h3>

					<div class="d-flex">
						<base-button type="primary" size="sm" @click="openAddUser = true">
							เพิ่ม
						</base-button>

						<el-select
							class="select-primary pagination-select mr-2"
							placeholder="Per page"
							v-model="pagination.perPage"
						>
							<el-option
								class="select-primary"
								v-for="item in pagination.perPageOptions"
								:key="item"
								:label="item"
								:value="item"
							/>
						</el-select>

						<input class="form-control" placeholder="ค้นหา ..." v-model="searchQuery" />
					</div>
				</template>
				<div>
					<el-table row-key="id" header-row-class-name="thead-light" :data="queriedData">
						<el-table-column label="ชื่อผู้ใช้งาน" min-width="150px">
							<div slot-scope="{ row }">{{ row.username }}</div>
						</el-table-column>
						<el-table-column label="ใช้งานล่าสุด" min-width="200px">
							<div slot-scope="{ row }">
								{{ row.updatedAt | moment('YYYY-MM-DD HH:mm:ss') }}<br />
								<small>
									{{ row.updatedAt | moment('from', 'now') }}
								</small>
							</div>
						</el-table-column>
						<el-table-column min-width="200px">
							<div slot-scope="{ row }">
								<base-button size="sm" @click="openEditUser = row">
									แก้ไข
								</base-button>
								<base-button
									type="primary"
									size="sm"
									@click="openTwoFactorModal = row.id"
									v-if="row.twoFactorSecret === ''"
								>
									เปิด 2FA
								</base-button>
								<base-button
									type="danger"
									size="sm"
									@click="disable2FA(row.id)"
									v-else
								>
									ปิด 2FA
								</base-button>
							</div>
						</el-table-column>
					</el-table>
				</div>
				<div class="col-12 d-flex justify-content-between" slot="footer">
					<p class="card-category">
						Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
					</p>

					<base-pagination
						class="pagination-no-border"
						:per-page="pagination.perPage"
						:total="total"
						v-model="pagination.currentPage"
					/>
				</div>
			</card>
		</div>

		<add-user-modal
			:open="openAddUser"
			:permissions="permissions"
			@close="openAddUser = false"
			@reloadUser="fetchUser"
		/>
		<edit-user-modal
			:open="openEditUser"
			:permissions="permissions"
			@close="openEditUser = null"
			@reloadUser="fetchUser"
		/>
		<enable-two-factor-modal
			:open="openTwoFactorModal !== 0"
			:userID="openTwoFactorModal"
			@close="openTwoFactorModal = 0"
			@refresh="fetchUser"
		/>
	</div>
</template>

<script>
import { Table, TableColumn, Select, Option } from 'element-ui'
import { BasePagination } from '../components'
import AddUserModal from '../backend-components/User/AddUserModal'
import EditUserModal from '../backend-components/User/EditUserModal'
import EnableTwoFactorModal from '../backend-components/User/EnableTwoFactorModal'

import UserService from '../services/user.service'
import tablePagination from '../mixins/tablePagination'

export default {
	mixins: [tablePagination(['username'])],
	components: {
		BasePagination,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[Select.name]: Select,
		[Option.name]: Option,
		AddUserModal,
		EditUserModal,
		EnableTwoFactorModal,
	},
	data() {
		return {
			loading: false,
			tableData: [],
			permissions: {},
			openAddUser: false,
			openEditUser: null,
			openTwoFactorModal: 0,
		}
	},
	methods: {
		fetchUser() {
			UserService.fetchUser()
				.then((res) => {
					this.updateTableData(res)
				})
				.catch(({ message }) => {
					this.$notify({ type: 'danger', message: message })
				})
		},
		updateStatus(user) {
			this.loading = true
			// MemberService.updateStatus(user.id, {
			// 	status: user.status === 0 ? 1 : 0,
			// })
			// 	.then(({ message }) => {
			// 		this.$notify({
			// 			type: 'success',
			// 			message: message,
			// 		})

			// 		this.fetchMember()
			// 	})
			// 	.catch(({ message }) => {
			// 		this.$notify({
			// 			type: 'danger',
			// 			message: message,
			// 		})
			// 	})
			// 	.finally(() => {
			// 		this.loading = false
			// 	})
		},
		async disable2FA(userID) {
			try {
				const res = await UserService.disable2FA(userID)

				this.fetchUser()
				this.$notify({ type: 'success', message: res.message })
			} catch ({ message }) {
				this.$notify({ type: 'danger', message: message })
			}
		},
	},
	created() {
		UserService.getPermissions().then((res) => {
			this.permissions = res
		})

		this.fetchUser()
	},
}
</script>
